// extracted by mini-css-extract-plugin
export default {"priceItemDark":"PriceItem_priceItemDark__w5jD6","item":"PriceItem_item__6xVOL","price":"PriceItem_price__nVPQs","priceItemLight":"PriceItem_priceItemLight__dyJlm"};